import { render, staticRenderFns } from "./RoutingModelsList.vue?vue&type=template&id=ba9e1ebe"
import script from "./RoutingModelsList.vue?vue&type=script&lang=js"
export * from "./RoutingModelsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports